import React from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Button from "react-bootstrap/esm/Button";
import { useNavigate } from "react-router-dom";

function CategorySortsSelect() {
  const navigate = useNavigate();
  return (
    <>
      <Card>
        <Card.Header>Select your version of Category Sorts!</Card.Header>
        <Card.Body>
          <Row>
            <Col
              style={{
                padding: "5px",
                margin: "5px",
                border: "solid 1px #333",
              }}
            >
              <Row>
                <h3 style={{ textAlign: "center", padding: "20px" }}>
                  In word match you drag the word to the corresponding group.
                </h3>
              </Row>
              <Row
                style={{
                  width: "100%",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Button
                    style={{
                      width: "200px",
                      height: "100px",
                      fontSize: "20px",
                    }}
                    onClick={() => navigate("/games/category-sorts")}
                  >
                    Word Match
                  </Button>
                </div>
              </Row>
            </Col>
            <Col
              style={{
                padding: "5px",
                margin: "5px",
                border: "solid 1px #333",
              }}
            >
              <Row>
                <h3 style={{ textAlign: "center", padding: "20px" }}>
                  In image match you drag the word to the corresponding image.
                </h3>
              </Row>
              <Row
                style={{
                  width: "100%",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Button
                    style={{
                      width: "200px",
                      height: "100px",
                      fontSize: "20px",
                    }}
                    onClick={() => navigate("/games/category-sorts-images")}
                  >
                    Image Match
                  </Button>
                </div>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
}

export default CategorySortsSelect;
